import { render, staticRenderFns } from "./wzbMiddle.vue?vue&type=template&id=0eb4c352&scoped=true&"
import script from "./wzbMiddle.vue?vue&type=script&lang=js&"
export * from "./wzbMiddle.vue?vue&type=script&lang=js&"
import style0 from "./wzbMiddle.vue?vue&type=style&index=0&id=0eb4c352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb4c352",
  null
  
)

export default component.exports